import IssueTabs from '@/components/issues/tabs/IssueTabs';
import IssueTabsPanels from '@/components/issues/tabs/IssueTabsPanels';
import { ISSUE_DETAIL_PANELS, ISSUE_DETAIL_PANELS_ROUTES } from '@/constants/app/issues/tabs';
import type { Issue } from '@/types';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';
import { TabContext } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const IssueDetails = ({ hide, props }: ModalChildrenProps) => {
  const issue = props?.issue as Issue;
  const [activeTab, setActiveTab] = useState(ISSUE_DETAIL_PANELS_ROUTES[0]);
  const navigate = useNavigate();

  if (!issue) return null;

  const handleLocation = (tab: string) => {
    setActiveTab(tab);
  };

  const handleCreateCase = () => {
    const params = new URLSearchParams({
      issue_id: issue.id,
      location_id: issue.location_id.toString(),
      atm_id: issue.atm_id.toString(),
    });
    hide();
    navigate(`/cases/create?${params.toString()}`);
  };

  return (
    <>
      <DialogContent sx={{ my: 2, maxWidth: 552, width: '100vw' }}>
        <TabContext value={activeTab}>
          <IssueTabs
            panels={ISSUE_DETAIL_PANELS}
            routes={ISSUE_DETAIL_PANELS_ROUTES}
            onChange={handleLocation}
          />
          <IssueTabsPanels issue={issue} hide={hide} />
        </TabContext>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="contained" onClick={hide}>
          Back to Issues
        </Button>
        {!issue.linked_case_id && (
          <Button variant="outlined" onClick={handleCreateCase}>
            Create Case
          </Button>
        )}
      </DialogActions>
    </>
  );
};

export default IssueDetails;
